export default "__VITE_ASSET__C$Na5cx6__"